/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { isIOS, isMac, isTouchDevice } from "dc-preview-utils/src/Utils/DeviceUtils";
import { providers } from "dc-core";

export const download = (buffer, subtype, fileName, extensionToSaveAs = "", assetUri = "", windowObj = window) =>
  new Promise((resolve, reject) => {
    if (buffer) {
      let fileDataBlob = new Blob([buffer], { type: subtype });

      if (!fileName) fileName = "Untitled";
      let fileNameToSaveAs = "";
      try {
        fileNameToSaveAs = decodeURIComponent(fileName);
      } catch (error) {
        fileNameToSaveAs = fileName;
      }
      if (extensionToSaveAs.length > 0) {
        fileNameToSaveAs += `.${extensionToSaveAs}`;
      }
      let a = document.createElement("a");

      if (a.download !== undefined) {
        a.id = "downloadLink";
        a.setAttribute("download", fileNameToSaveAs);
        a.style.display = "none";
        if (isIOS() || (isMac() && isTouchDevice())) {
          let fr = new FileReader();
          fr.onloadend = function(e) {
            if (e.target.result.match(/^data:[^;]*;/)) {
              let url = e.target.result.replace(/^data:[^;]*;/, "data:attachment/file;");
              a.href = url;
              document.body.appendChild(a);
              a.click();
              a.remove();
              resolve();
            }
          };
          fr.readAsDataURL(fileDataBlob);
        } else {
          let url = URL.createObjectURL(fileDataBlob);
          a.href = url;
          document.body.appendChild(a);
          a.click();
          a.remove();
          resolve();
        }
      } else if (windowObj.navigator.msSaveBlob) {
        // IE download attribute not supportd, hence downloading file using msSaveBlob API
        windowObj.navigator.msSaveBlob(fileDataBlob, fileNameToSaveAs);
        resolve();
      } else if (assetUri) {
        downloadUsingAssetURI(assetUri, windowObj).then(resolve, reject);
      } else {
        // In safari 12 download Attribute is not supported, hence downloading file as attachment
        let fr = new FileReader(); // In safari download Attribute is not supported, hence downloading file as attachment
        fr.onloadend = function(e) {
          if (e.target.result.match(/^data:[^;]*;/)) {
            var url = e.target.result.replace(/^data:[^;]*;/, "data:attachment/file;");
            windowObj.location.href = url;
            resolve();
          }
        };
        fr.readAsDataURL(fileDataBlob);
      }
    } else {
      reject("File Buffer Empty!!!");
    }
  });

export const downloadUsingAssetURI = (assetUri, windowObj = window) =>
  new Promise((resolve, reject) => {
    providers.asset().then(asset => {
      asset
        .getDownloadURI(
          { asset_id: assetUri },
          {
            uri_parameters: {
              make_ticket: true
            }
          }
        )
        .then(result => {
          windowObj.location.href = result.uri;
          resolve();
        }, reject);
    }, reject);
  });
